import { TCountryValidation } from './validationByCountryCode';

export default (cocNumber: string, validation?: TCountryValidation): boolean => {
  if (!validation) {
    return false;
  }
  return validation.pattern.test(cocNumber);
};
